import { render, staticRenderFns } from "./saturation.vue?vue&type=template&id=90646cae&"
import script from "./saturation.vue?vue&type=script&lang=js&"
export * from "./saturation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90646cae')) {
      api.createRecord('90646cae', component.options)
    } else {
      api.reload('90646cae', component.options)
    }
    module.hot.accept("./saturation.vue?vue&type=template&id=90646cae&", function () {
      api.rerender('90646cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-picker/saturation.vue"
export default component.exports